module.exports = __webpack_public_path__ + "static/media/box-resources-02.70ff6ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/box-resources-02.png
// module id = 379
// module chunks = 0